import MovementsByTypeForm from './MovementsByTypeForm'

export default MovementsByTypeForm
